import { Dispatch } from '@reduxjs/toolkit';
import { getStore } from 'redux/reemaStore';
import { ApiRequestError } from './api-request';

export const setErrorToast = (error: ApiRequestError, dispatch: Dispatch) => {
  if (error.name !== 'HttpError' || error.body['statusCode'] === 400) {
    return;
  }

  const statusCode = error.body['statusCode'];

  // Suppress toasts for member access errors (handled by ProtectedMemberPage component)
  if (
    error.isAccessDenied === true &&
    (statusCode === 404 || statusCode === 401)
  ) {
    return;
  }

  // Suppress toasts for unauthenticated 401 errors (handled by ProtectedRoute)
  if (statusCode === 401) {
    const state = getStore().getState();
    if (!state.actingUser?.isAuthenticated) {
      return;
    }
  }

  const details = {
    path: error.body['path'],
    code: error.body['statusCode'],
    userMessage: error.body['userMessage'],
    timestamp: error.body['timestamp'],
    errors: error.body['errors'],
    link: error.body['link'],
  };

  dispatch({
    type: 'metaData/setToast',
    payload: {
      message: `An error has occurred: ${error?.body['userMessage']}.\n\nClick the copy button and paste error message in
#reema-app-help channel with steps taken when error occurred.`,
      severity: 'error',
      details,
    },
  });
};
